import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[soloNumerosEnterosPositivos]'
})
export class SoloNumerosEnterosPositivosDirective  {

    constructor(private el: ElementRef) {}

    @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent) {
      const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'];
      if (!allowedKeys.includes(event.key) && !this.isNumberKey(event.key)) {
        event.preventDefault();
      }
    }
  
    @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
      const pastedText:string | undefined = event.clipboardData?.getData('text/plain');
      if (!this.isNumberString(pastedText)) {
        event.preventDefault();
      }
    }
  
    private isNumberKey(key: string): boolean {
      return /[0-9]/.test(key);
    }
  
    private isNumberString(str: string|undefined): boolean {
        if (str != undefined) {
            return /^[0-9]+$/.test(str);
        }
        return false;
    }

}